import { Injectable } from '@angular/core';
import { IDataLoader } from '@interfaces/fui-components/select.interface';
import { BehaviorSubject, catchError, Observable, of, tap } from 'rxjs';

/**
 * Вспомогательный сервис для работы с компонентом fui-select библиотеки F-UI Components
 */
@Injectable({ providedIn: 'root' })
export class FuiSelectService {
    /**
     * Хелпер для индикации загрузки данных
     */
    getLoader<TItem>(provider: Observable<TItem[]>): IDataLoader<TItem> {
        const loading$ = new BehaviorSubject<boolean>(true);
        const result = {
            data$: provider.pipe(
                tap(() => loading$.next(false)),
                catchError(() => {
                    loading$.next(false);
                    return of([]);
                }),
            ),
            loading$,
        };
        return result;
    }
}
